import ocrApi from "./ocrApi";

function emptyAnalysis() {
  return {
    review_threshold: 85,
    files_analysed: 0,
    words_recognised: 0,
    median_page_confidence: null,
    pages_needing_review: 0,
    page_confidence: [],
    tables_by_type: [],
    tables_per_page: [],
    table_status: [],
    word_confidence_histogram: { bin_edges: [], counts: [] },
    review_pages: [],
    processing_runs: [],
  };
}

export function buildFallbackDashboardPayload(summary, memory) {
  const counts = summary?.file_counts || {};
  const completed = counts.completed ?? counts.processed ?? 0;
  const uploaded = counts.uploaded ?? 0;
  return {
    tenant: summary?.tenant ?? "",
    folder: summary?.folder ?? "",
    cache_ttl_minutes: 2,
    overview: {
      kpis: {
        files_processed: completed,
        pages_digitized: 0,
        avg_ocr_confidence: null,
        waiting: uploaded,
        failed: 0,
      },
      processing_trend: [],
      status_counts: [
        { status: "Processed", count: completed },
        { status: "Waiting", count: uploaded },
      ].filter((r) => r.count > 0),
      recent_files: [],
      processing_now: null,
      memory: {
        system_memory_percent: memory?.system_memory_percent ?? 0,
        system_memory_available_gb: memory?.system_memory_available_gb ?? 0,
        process_memory_mb: memory?.process_memory_mb ?? 0,
        session_size_mb: memory?.session_size_mb ?? 0,
        files_in_memory: memory?.files_in_memory ?? 0,
      },
    },
    files: [],
    reported_documents: [],
    analysis: emptyAnalysis(),
    _fallback: true,
  };
}

export async function fetchDashboardPayload() {
  try {
    const { data } = await ocrApi.get("api/v1/dashboard/data");
    return data;
  } catch {
    const [summaryRes, memRes] = await Promise.all([
      ocrApi.get("api/v1/dashboard/summary"),
      ocrApi.get("api/v1/dashboard/memory"),
    ]);
    return buildFallbackDashboardPayload(summaryRes.data, memRes.data);
  }
}
